import { render, staticRenderFns } from "./CoursePrice.vue?vue&type=template&id=11ea7066&scoped=true"
import script from "./CoursePrice.vue?vue&type=script&lang=js"
export * from "./CoursePrice.vue?vue&type=script&lang=js"
import style0 from "./CoursePrice.vue?vue&type=style&index=0&id=11ea7066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ea7066",
  null
  
)

export default component.exports